// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Styles RTL pour la Sidebar */

/* ========================================
   HEADER DE LA SIDEBAR 
   ======================================== */

/* En RTL, inverser la position du titre et de l'icône de fermeture */
.rtl-layout .MuiDrawer-root .MuiPaper-root {
    right: 0 !important;
    left: auto !important;
}

/* DrawerHeader - inverser la direction */
.rtl-layout .css-12i7wg6-MuiPaper-root-MuiDrawer-paper > div:first-child,
.rtl-layout [class*="DrawerHeader"] {
    flex-direction: row-reverse !important;
    justify-content: space-between !important;
}

/* Titre de la sidebar - aligner à droite en RTL */
.rtl-layout .MuiDrawer-root h2 {
    text-align: right !important;
    margin-right: auto !important;
    margin-left: 0 !important;
}

/* ========================================
   ICÔNES DE CHEVRON (OUVERTURE/FERMETURE)
   ======================================== */

/* Remplacer ChevronLeftIcon par ChevronRightIcon en RTL */
.rtl-layout .MuiDrawer-root .MuiSvgIcon-root[data-testid="ChevronLeftIcon"] {
    transform: scaleX(-1) !important;
}

/* Remplacer ChevronRightIcon par ChevronLeftIcon en RTL */
.rtl-layout .MuiDrawer-root .MuiSvgIcon-root[data-testid="ChevronRightIcon"] {
    transform: scaleX(-1) !important;
}

/* Alternative avec sélecteur plus générique */
.rtl-layout .MuiDrawer-root .MuiIconButton-root .MuiSvgIcon-root {
    transform: scaleX(-1) !important;
}

/* ========================================
   ÉLÉMENTS DE LISTE DE NAVIGATION
   ======================================== */

/* ListItemButton - inverser la direction */
.rtl-layout .MuiDrawer-root .MuiListItemButton-root {
    flex-direction: row-reverse !important;
    padding-right: 20px !important;
    padding-left: 20px !important;
}

/* ListItemIcon - repositionner à droite */
.rtl-layout .MuiDrawer-root .MuiListItemIcon-root {
    margin-right: 0 !important;
    margin-left: 24px !important; /* Équivalent de mr: 3 en RTL */
    justify-content: center !important;
}

/* Quand la sidebar est fermée, centrer l'icône */
.rtl-layout .MuiDrawer-root .MuiListItemIcon-root[style*="margin-left: auto"] {
    margin-left: auto !important;
    margin-right: auto !important;
}

/* ListItemText/Typography - aligner à droite */
.rtl-layout .MuiDrawer-root .MuiListItemButton-root .MuiTypography-root {
    text-align: right !important;
    margin-right: auto !important;
    margin-left: 0 !important;
}

/* Tooltip positioning pour RTL */
.rtl-layout .MuiTooltip-popper[data-popper-placement^="left"] {
    /* Les tooltips "left" deviennent "right" en RTL */
    transform: translateX(10px) !important;
}

/* ========================================
   ANIMATIONS ET TRANSITIONS
   ======================================== */

/* S'assurer que les transitions sont fluides */
.rtl-layout .MuiDrawer-root .MuiListItemIcon-root,
.rtl-layout .MuiDrawer-root .MuiListItemButton-root,
.rtl-layout .MuiDrawer-root .MuiTypography-root {
    transition: margin 0.2s ease, padding 0.2s ease, text-align 0.2s ease !important;
}

/* ========================================
   ÉTAT FERMÉ DE LA SIDEBAR
   ======================================== */

/* Quand la sidebar est fermée, ajustements RTL */
.rtl-layout .MuiDrawer-root[style*="width: 65px"] .MuiListItemButton-root {
    justify-content: center !important;
    flex-direction: column !important;
}

/* ========================================
   SECTION BOTTOM (Profil, déconnexion, etc.)
   ======================================== */

/* Si il y a une section bottom, l'inverser aussi */
.rtl-layout .MuiDrawer-root .MuiStack-root {
    direction: rtl !important;
}

/* Dividers - s'assurer qu'ils s'étendent sur toute la largeur */
.rtl-layout .MuiDrawer-root .MuiDivider-root {
    margin: 0 !important;
}

/* ========================================
   SÉLECTEURS SPÉCIFIQUES POUR VOTRE APP
   ======================================== */

/* Si vous avez des classes personnalisées, ajustez-les ici */
.rtl-layout .sidebar-logo {
    margin-right: 0 !important;
    margin-left: auto !important;
}

.rtl-layout .sidebar-menu-item {
    flex-direction: row-reverse !important;
}

.rtl-layout .sidebar-menu-text {
    text-align: right !important;
    padding-right: 0 !important;
    padding-left: 16px !important;
}

/* ========================================
   RESPONSIVE - MOBILE
   ======================================== */

@media (max-width: 768px) {
    .rtl-layout .MuiDrawer-root {
        right: 0 !important;
        left: auto !important;
    }
    
    .rtl-layout .MuiDrawer-root .MuiPaper-root {
        transform: translateX(0) !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/sidebar-rtl.css"],"names":[],"mappings":"AAAA,+BAA+B;;AAE/B;;6CAE6C;;AAE7C,qEAAqE;AACrE;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA,yCAAyC;AACzC;;IAEI,sCAAsC;IACtC,yCAAyC;AAC7C;;AAEA,kDAAkD;AAClD;IACI,4BAA4B;IAC5B,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;;6CAE6C;;AAE7C,0DAA0D;AAC1D;IACI,gCAAgC;AACpC;;AAEA,0DAA0D;AAC1D;IACI,gCAAgC;AACpC;;AAEA,8CAA8C;AAC9C;IACI,gCAAgC;AACpC;;AAEA;;6CAE6C;;AAE7C,2CAA2C;AAC3C;IACI,sCAAsC;IACtC,8BAA8B;IAC9B,6BAA6B;AACjC;;AAEA,0CAA0C;AAC1C;IACI,0BAA0B;IAC1B,4BAA4B,EAAE,+BAA+B;IAC7D,kCAAkC;AACtC;;AAEA,iDAAiD;AACjD;IACI,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA,+CAA+C;AAC/C;IACI,4BAA4B;IAC5B,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA,iCAAiC;AACjC;IACI,kDAAkD;IAClD,sCAAsC;AAC1C;;AAEA;;6CAE6C;;AAE7C,+CAA+C;AAC/C;;;IAGI,gFAAgF;AACpF;;AAEA;;6CAE6C;;AAE7C,iDAAiD;AACjD;IACI,kCAAkC;IAClC,iCAAiC;AACrC;;AAEA;;6CAE6C;;AAE7C,mDAAmD;AACnD;IACI,yBAAyB;AAC7B;;AAEA,gEAAgE;AAChE;IACI,oBAAoB;AACxB;;AAEA;;6CAE6C;;AAE7C,6DAA6D;AAC7D;IACI,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,4BAA4B;IAC5B,2BAA2B;IAC3B,6BAA6B;AACjC;;AAEA;;6CAE6C;;AAE7C;IACI;QACI,mBAAmB;QACnB,qBAAqB;IACzB;;IAEA;QACI,mCAAmC;IACvC;AACJ","sourcesContent":["/* Styles RTL pour la Sidebar */\n\n/* ========================================\n   HEADER DE LA SIDEBAR \n   ======================================== */\n\n/* En RTL, inverser la position du titre et de l'icône de fermeture */\n.rtl-layout .MuiDrawer-root .MuiPaper-root {\n    right: 0 !important;\n    left: auto !important;\n}\n\n/* DrawerHeader - inverser la direction */\n.rtl-layout .css-12i7wg6-MuiPaper-root-MuiDrawer-paper > div:first-child,\n.rtl-layout [class*=\"DrawerHeader\"] {\n    flex-direction: row-reverse !important;\n    justify-content: space-between !important;\n}\n\n/* Titre de la sidebar - aligner à droite en RTL */\n.rtl-layout .MuiDrawer-root h2 {\n    text-align: right !important;\n    margin-right: auto !important;\n    margin-left: 0 !important;\n}\n\n/* ========================================\n   ICÔNES DE CHEVRON (OUVERTURE/FERMETURE)\n   ======================================== */\n\n/* Remplacer ChevronLeftIcon par ChevronRightIcon en RTL */\n.rtl-layout .MuiDrawer-root .MuiSvgIcon-root[data-testid=\"ChevronLeftIcon\"] {\n    transform: scaleX(-1) !important;\n}\n\n/* Remplacer ChevronRightIcon par ChevronLeftIcon en RTL */\n.rtl-layout .MuiDrawer-root .MuiSvgIcon-root[data-testid=\"ChevronRightIcon\"] {\n    transform: scaleX(-1) !important;\n}\n\n/* Alternative avec sélecteur plus générique */\n.rtl-layout .MuiDrawer-root .MuiIconButton-root .MuiSvgIcon-root {\n    transform: scaleX(-1) !important;\n}\n\n/* ========================================\n   ÉLÉMENTS DE LISTE DE NAVIGATION\n   ======================================== */\n\n/* ListItemButton - inverser la direction */\n.rtl-layout .MuiDrawer-root .MuiListItemButton-root {\n    flex-direction: row-reverse !important;\n    padding-right: 20px !important;\n    padding-left: 20px !important;\n}\n\n/* ListItemIcon - repositionner à droite */\n.rtl-layout .MuiDrawer-root .MuiListItemIcon-root {\n    margin-right: 0 !important;\n    margin-left: 24px !important; /* Équivalent de mr: 3 en RTL */\n    justify-content: center !important;\n}\n\n/* Quand la sidebar est fermée, centrer l'icône */\n.rtl-layout .MuiDrawer-root .MuiListItemIcon-root[style*=\"margin-left: auto\"] {\n    margin-left: auto !important;\n    margin-right: auto !important;\n}\n\n/* ListItemText/Typography - aligner à droite */\n.rtl-layout .MuiDrawer-root .MuiListItemButton-root .MuiTypography-root {\n    text-align: right !important;\n    margin-right: auto !important;\n    margin-left: 0 !important;\n}\n\n/* Tooltip positioning pour RTL */\n.rtl-layout .MuiTooltip-popper[data-popper-placement^=\"left\"] {\n    /* Les tooltips \"left\" deviennent \"right\" en RTL */\n    transform: translateX(10px) !important;\n}\n\n/* ========================================\n   ANIMATIONS ET TRANSITIONS\n   ======================================== */\n\n/* S'assurer que les transitions sont fluides */\n.rtl-layout .MuiDrawer-root .MuiListItemIcon-root,\n.rtl-layout .MuiDrawer-root .MuiListItemButton-root,\n.rtl-layout .MuiDrawer-root .MuiTypography-root {\n    transition: margin 0.2s ease, padding 0.2s ease, text-align 0.2s ease !important;\n}\n\n/* ========================================\n   ÉTAT FERMÉ DE LA SIDEBAR\n   ======================================== */\n\n/* Quand la sidebar est fermée, ajustements RTL */\n.rtl-layout .MuiDrawer-root[style*=\"width: 65px\"] .MuiListItemButton-root {\n    justify-content: center !important;\n    flex-direction: column !important;\n}\n\n/* ========================================\n   SECTION BOTTOM (Profil, déconnexion, etc.)\n   ======================================== */\n\n/* Si il y a une section bottom, l'inverser aussi */\n.rtl-layout .MuiDrawer-root .MuiStack-root {\n    direction: rtl !important;\n}\n\n/* Dividers - s'assurer qu'ils s'étendent sur toute la largeur */\n.rtl-layout .MuiDrawer-root .MuiDivider-root {\n    margin: 0 !important;\n}\n\n/* ========================================\n   SÉLECTEURS SPÉCIFIQUES POUR VOTRE APP\n   ======================================== */\n\n/* Si vous avez des classes personnalisées, ajustez-les ici */\n.rtl-layout .sidebar-logo {\n    margin-right: 0 !important;\n    margin-left: auto !important;\n}\n\n.rtl-layout .sidebar-menu-item {\n    flex-direction: row-reverse !important;\n}\n\n.rtl-layout .sidebar-menu-text {\n    text-align: right !important;\n    padding-right: 0 !important;\n    padding-left: 16px !important;\n}\n\n/* ========================================\n   RESPONSIVE - MOBILE\n   ======================================== */\n\n@media (max-width: 768px) {\n    .rtl-layout .MuiDrawer-root {\n        right: 0 !important;\n        left: auto !important;\n    }\n    \n    .rtl-layout .MuiDrawer-root .MuiPaper-root {\n        transform: translateX(0) !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
